/** Falha de uma chamada, já traduzida para o que a interface precisa exibir. */
export class ErroDaGeoEngine extends Error {
    codigo;
    registro;
    constructor(codigo, mensagem, registro) {
        super(mensagem);
        this.name = 'ErroDaGeoEngine';
        this.codigo = codigo;
        this.registro = registro;
    }
}
function ehRespostaDeErro(corpo) {
    return (typeof corpo === 'object' &&
        corpo !== null &&
        typeof corpo.erro === 'string' &&
        typeof corpo.mensagem === 'string');
}
const MENSAGEM_POR_STATUS = {
    401: 'Token ausente ou inválido. Informe um token válido para continuar.',
    404: 'Recurso não encontrado na Geo-Engine.',
    503: 'Geo-Engine indisponível no momento.',
};
/** Converte a resposta HTTP malsucedida no contrato de erro da Geo-Engine. */
export function interpretarErro(corpo, registro) {
    if (ehRespostaDeErro(corpo)) {
        return new ErroDaGeoEngine(corpo.erro, corpo.mensagem, registro);
    }
    const mensagem = MENSAGEM_POR_STATUS[registro.status] ??
        `A Geo-Engine respondeu ${registro.status} sem o contrato de erro esperado.`;
    return new ErroDaGeoEngine('resposta_inesperada', mensagem, registro);
}
